import { useEffect, useMemo, useState } from 'react';
import { FacilitiesApi } from '@/api/clients/facilities';

export const useGetAllowedAttachmentTypes = ({
  refundType,
  facilityId,
  isCustomPaymentTypesEnabled,
}) => {
  const [allowedAttachments, setAllowedAttachments] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchAllowedAttachmentTypes = async () => {
    setLoading(true);
    try {
      const { data } = await FacilitiesApi.getAllowedAttachmentTypes(
        facilityId,
      );
      setAllowedAttachments(data.allowed_refund_attachments);
    } catch (error) {
      console.error('Error fetching allowed attachment types:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!isCustomPaymentTypesEnabled && facilityId)
      fetchAllowedAttachmentTypes();
  }, [facilityId, isCustomPaymentTypesEnabled]);

  const showAttachments = useMemo(() => {
    if (!refundType) return false;

    return (
      allowedAttachments?.some((attachment) => attachment === refundType) ||
      false
    );
  }, [refundType, allowedAttachments, facilityId, isCustomPaymentTypesEnabled]);

  return {
    allowedAttachments,
    showAttachments,
    loading,
  };
};
